import type { AgingContactDrillDown } from '@/pages/AgingReportPage'

export function agingInvoiceDrillDownPath(drillDown: AgingContactDrillDown) {
  const params = new URLSearchParams({
    aging_contact_id: String(drillDown.contactId),
    aging_contact_name: drillDown.contactName,
  })
  return `/finance/invoices?${params.toString()}`
}

export function agingInvoiceDrillDownFromSearch(search: string): AgingContactDrillDown | undefined {
  const params = new URLSearchParams(search)
  const contactId = Number(params.get('aging_contact_id'))
  const contactName = params.get('aging_contact_name')
  if (!Number.isInteger(contactId) || contactId <= 0 || !contactName) return undefined

  return { contactId, contactName }
}
